import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, OnInit } from '@angular/core';
/*, Sanitizer, SecurityContext, ChangeDetectorRef, ChangeDetectionStrategy*/
import { SessionService } from '../commons/session.service';
import { CartService } from '../commons/cart.service';


// import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
@Component({
  selector: 'similFancy',
  template: require('./similFancy.component.html'),
  // changeDetection: ChangeDetectionStrategy.Default
})


export class SimilFancyComponent implements OnChanges, OnInit {

  // public imgSrcSanitize: string;

  @ViewChild('imgSimilFancy') imgSimilFancy: ElementRef;

  @Input() imgRounded: boolean;
  @Input() imgSrc: string;
  @Input() nameId: string;
  @Output() clickBtn = new EventEmitter();


  public visibleLoader: boolean = false;

  constructor(
    private session: SessionService,
    private cartService: CartService
  ) { }

  ngOnInit() {

    this.loaderSFRefresh();

    // // CURSORE CON FONTAWESOME
    // let canvas = document.createElement('canvas');
    // canvas.width = 24;
    // canvas.height = 24;
    // let ctx = canvas.getContext('2d');
    // ctx.fillStyle = '#fff';
    // ctx.font = '24px FontAwesome';
    // ctx.textAlign = 'center';
    // ctx.textBaseline = 'middle';
    // ctx.fillText('\uf002', 12, 12);
    // let dataURL = canvas.toDataURL('image/png');

    // let container = document.getElementById(this.nameId);
    // if (container) {
    //   let previewImg = container.getElementsByClassName('previewImg')[0] as HTMLElement;
    //   // if (previewImg) {
    //   if (this.cartService.cart.currentCartProduct.photoResized != null && previewImg) {
    //     // previewImg.style.cursor = ':url(' + dataURL + '), auto;';
    //     previewImg.setAttribute('style', 'cursor:url(' + dataURL + '), auto;');
    //   }
    // }


  }

  ngOnChanges() {
    this.loaderSFRefresh();
  }


  loaderSFRefresh() {
    //console.log('loaderSFRefresh');

    this.visibleLoader = true;

    setTimeout(() => {
      //console.log('if this.imgSimilFancy.complete: ' + this.imgSimilFancy.nativeElement.complete);
      if (this.imgSimilFancy.nativeElement.complete) {
        this.visibleLoader = false;
      } else {
        this.loaderSFRefresh();
      }
    }, 500);
  }



  clickShowImg() {
    let container = document.getElementById(this.nameId);
    let ImgSrc = container.getElementsByClassName('linkPrevImg')[0];
    let ImgThumb = container.getElementsByClassName('ImgThumb')[0];

    if (ImgSrc.className === 'linkPrevImg fancyOpen center-content') {
      ImgSrc.className = 'linkPrevImg fancyClose';
      ImgThumb.className = 'ImgThumb hidden';
    } else {
      ImgSrc.className = 'linkPrevImg fancyOpen center-content';
      ImgThumb.className = 'ImgThumb show';
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/similFancy.component.ts